import { Component } from "./Component";
import { reducer } from "./redux/reducer";
import { rootSaga } from "./redux/sagas";
import { AuthComponentDefinition } from "../common/ModuleProps";

export const azureAuthorization: AuthComponentDefinition = {
  module: {
    component: Component,
    redux: {
      name: "auth",
      reducer,
      saga: rootSaga,
    },
  },
};
